import { UpgradeDialog } from "@/components/UpgradeDialog";
import { Lock } from "lucide-react";

export function LockedOverlay({ label = "Unlock with Pro" }) {
  return (
    <div className="absolute inset-0 z-20 rounded-[inherit] backdrop-blur-[6px] bg-[#0A0D14]/55 grid place-items-center">
      <UpgradeDialog trigger={
        <button data-testid="locked-upgrade-cta"
          className="flex items-center gap-1.5 px-4 py-2 rounded-full bg-[#F59E0B] text-black text-xs font-semibold hover:bg-[#d98c08] transition-colors shadow-lg">
          <Lock size={13} /> {label}
        </button>
      } />
    </div>
  );
}
